import React from 'react';
import moment from 'moment';
import axios from 'axios';
import qs from 'qs';
import { connect } from 'react-redux';
import { DateTimePicker } from '@material-ui/pickers';
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import CalendarHeader from '../parts/CalendarHeader';
import MentalHealthEntryCard from '../parts/MentalHealthEntryCard';
import Survey from '../parts/Wellbeing/Survey';
import ConfirmDialog from '../parts/ConfirmDialog';
import MentalHealthEditDialog from '../parts/Dialogs/MentalHealthEditDialog';
import { setData } from '../../actions/index';

const styles = theme => ({
  divider: {
    margin: '40px 0',
  },
  sectionHeading: {
    color: '#394f5a',
  },
  sectionSubHeading: {
    fontSize: 14,
    textAlign: 'center',
    color: '#0a72c7',
    margin: '30px 0 10px',
  },
  guidelineText: {
    color: '#394f5a',
    marginTop: 10,
    fontSize: 14,
  },
  scoresWrapper: {
    margin: '20px 0 40px',
    display: 'flex',
  },
  textAlignRight: {
    textAlign: 'right',
  },
  noteField: {
    width: '100%',
    marginBottom: 20,
  },
  formControl: {
    width: '100%',
  },
  scoreWrapper: {
    textAlign: 'center',
    flex: 1,
    cursor: 'pointer',
    '& img': {
      maxWidth: 48,
      padding: 8,
    },
    '&:hover img': {
      maxWidth: 64,
      padding: 0,
    },
  },
  scoreWrapperActive: {
    '& img': {
      maxWidth: 64,
      padding: 0,
    },
  },
  scoreLabel: {
    fontSize: 13,
  },
  saveButton: {
    marginTop: 10,
    padding: '8px 16px',
    backgroundColor: '#f56a12',
    '&:hover': {
      backgroundColor: '#C24C03',
    },
  },
});

const mapStateToProps = state => {
  return {
    user: state.user,
    selectedPupil: state.selectedPupil,
    defaultDateRange: state.defaultDateRange,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setData: (data, type) => dispatch(setData(data, type)),
  };
}

class MentalHealthPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      isLoading: false,
      isLoaded: false,
      meta: [],
      isDialogOpen: false,
      dialogText: '',
      dialogSelectedMentalHealthEntry: null,
      isEditDialogOpen: false,
      editDialogSelectedMentalHealthEntry: null,
      editDialogData: {
        timestamp: moment(),
        tracker: '',
        note: '',
      },
      dateStart: null,
      dateEnd: null,
      score: null,
      timestamp: moment(),
      tracker: '',
      note: '',
    };

    this.axiosCancel = null;

    this.onScoreClick = this.onScoreClick.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
    this.onDialogClose = this.onDialogClose.bind(this);
    this.onDialogConfirm = this.onDialogConfirm.bind(this);
    this.onEditDialogClose = this.onEditDialogClose.bind(this);
    this.onEditDialogConfirm = this.onEditDialogConfirm.bind(this);
    this.onDeleteClick = this.onDeleteClick.bind(this);
    this.onEditClick = this.onEditClick.bind(this);
    this.onRangeChanged = this.onRangeChanged.bind(this);
  }

  componentDidMount() {
    const {
      defaultDateRange,
    } = this.props;

    if (defaultDateRange !== null) {
      this.setState({
        dateStart: defaultDateRange[0],
        dateEnd: defaultDateRange[1],
      }, () => {
        this.reloadData();
      });
    } else {
      this.reloadData();
    }
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  reloadData() {
    const {
      selectedPupil,
    } = this.props;
    const {
      dateStart,
      dateEnd,
    } = this.state;

    if (!selectedPupil) {
      return;
    }

    this.setState({
      isLoading: true,
      isLoaded: false,
    });

    let dateQuery = '';
    if (dateStart && dateEnd) {
      dateQuery += `?from=${moment(dateStart).format('YYYY-MM-DD')}&to=${moment(dateEnd).format('YYYY-MM-DD')}`;
    }

    axios
      .get(
        `${window.apiUrl}/tracking/${selectedPupil.id}${dateQuery}`,
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          this.setState({
            data: response.data.data,
            meta: response.data.meta,
            dateStart: response.data.meta.start_date,
            dateEnd: response.data.meta.end_date,
          });

          if (!selectedPupil.display_mental_health_no_tracker) {
            const trackers = response.data.meta.trackers;
            if (
              trackers &&
              Object.keys(trackers).length > 0
            ) {
              this.setState({
                tracker: Object.keys(trackers)[0],
              });
            }
          }
        }

        this.setState({
          isLoading: false,
          isLoaded: true,
        });
      })
      .catch((thrown) => {});
  }

  onScoreClick(score) {
    this.setState({
      score,
    });
  }

  onInputChange(event) {
    if (event.target.name.indexOf('editDialogData.') !== -1) {
      const name = event.target.name.replace('editDialogData.', '');
      const { editDialogData } = this.state;
      editDialogData[name] = event.target.value;

      this.setState({
        editDialogData,
      });
    } else {
      this.setState({
        [event.target.name]: event.target.value,
      });
    }
  }

  onSaveClick() {
    const {
      enqueueSnackbar,
      t,
      selectedPupil,
    } = this.props;

    axios
      .post(
        `${window.apiUrl}/addtracking/${selectedPupil.id}`,
        qs.stringify({
          score: this.state.score,
          note: this.state.note,
          mental_health_tracker_id: this.state.tracker,
          timestamp: this.state.timestamp.format('YYYY-MM-DDTHH:mm:ss'),
        }),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          this.setState({
            score: null,
            timestamp: moment(),
            tracker: '',
            note: '',
          });
          this.reloadData();
        } else {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        }
      })
      .catch((thrown) => {
        if (
          !thrown.response &&
          !axios.isCancel(thrown)
        ) {
          enqueueSnackbar(t('Network error detected. Please make sure you are connected to the internet.'), {
            variant: 'error',
            autoHideDuration: 2000,
          });
        }
      });
  }

  onDialogClose() {
    this.setState({
      isDialogOpen: false,
    });
  }

  onDialogConfirm() {
    const {
      enqueueSnackbar,
      t,
    } = this.props;

    this.setState({
      isDialogOpen: false,
    });

    // We're in the deleting a mental health entry mode
    if (this.state.dialogSelectedMentalHealthEntry !== null) {
      axios
        .post(
          `${window.apiUrl}/deletetracking/${this.state.dialogSelectedMentalHealthEntry.id}`,
          qs.stringify({
            pupil_id: this.state.dialogSelectedMentalHealthEntry.pupil_id,
          }),
          {
            cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
          }
        )
        .then((response) => {
          if (response.data.success) {
            this.reloadData();
          } else {
            enqueueSnackbar(response.data.error, {
              variant: 'error',
              autoHideDuration: 2000,
            });
          }
        })
        .catch((thrown) => {});
    }
  }

  onEditDialogClose() {
    this.setState({
      isEditDialogOpen: false,
    });
  }

  onEditDialogConfirm() {
    const {
      enqueueSnackbar,
    } = this.props;

    axios
      .post(
        `${window.apiUrl}/edittracking/${this.state.editDialogSelectedMentalHealthEntry.id}`,
        qs.stringify({
          note: this.state.editDialogData.note,
          mental_health_tracker_id: this.state.editDialogData.tracker,
          pupil_id: this.state.editDialogSelectedMentalHealthEntry.pupil_id,
          timestamp: this.state.editDialogData.timestamp.format('YYYY-MM-DDTHH:mm:ss'),
        }),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          this.setState({
            isEditDialogOpen: false,
          });

          this.reloadData();
        } else {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        }
      })
      .catch((thrown) => {});
  }

  onDeleteClick(mentalHealthEntry) {
    const {
      enqueueSnackbar,
      t,
    } = this.props;

    this.setState({
      dialogText: t('Are you sure you want to remove this wellbeing entry?'),
      isDialogOpen: true,
      dialogSelectedMentalHealthEntry: mentalHealthEntry,
    });
  }

  onEditClick(mentalHealthEntry) {
    this.setState({
      isEditDialogOpen: true,
      editDialogSelectedMentalHealthEntry: mentalHealthEntry,
      editDialogData: {
        timestamp: moment(mentalHealthEntry.timestamp),
        tracker: mentalHealthEntry.mental_health_tracker_id
          ? mentalHealthEntry.mental_health_tracker_id
          : '',
        note: mentalHealthEntry.note,
      },
    });
  }

  onRangeChanged(range) {
    const dateStart = range[0].format('YYYY-MM-DD');
    const dateEnd = range[1].format('YYYY-MM-DD');

    this.setState({
      dateStart,
      dateEnd,
    }, () => {
      this.reloadData();
    });

    this.props.setData(range, 'defaultDateRange');
  }

  render() {
    const {
      classes,
      t,
      selectedPupil,
      user,
    } = this.props;
    const {
      data,
      meta,
      isLoaded,
      isLoading,
      isDialogOpen,
      dialogText,
      isEditDialogOpen,
      editDialogData,
      dateStart,
      dateEnd,
      score,
      timestamp,
      note,
      tracker: originalTracker,
    } = this.state;

    const scores = [-2, -1, 0, 1, 2];
    const headingText = appType === 'student'
      ? t('How are you feeling? (this will be shared with the school)')
      : t('How is {pupil_name} feeling? (this will be shared with the school)')
        .replace('{pupil_name}', selectedPupil.first_name);

    let lastDate = '';
    let tracker = originalTracker;

    if (
      !tracker &&
      !selectedPupil.display_mental_health_no_tracker &&
      meta.trackers &&
      Object.keys(meta.trackers).length > 0
    ) {
      tracker = Object.keys(meta.trackers)[0];
    }

    return (
      <div className="mental-health-page">
        <Survey />
        <CalendarHeader
          dateText={t('Date range')}
          dateFormat={dateFormat}
          dateStart={dateStart}
          dateEnd={dateEnd}
          onRangeChanged={this.onRangeChanged}
          useSuspense={false}
        />
        {isLoading && !isLoaded && (
          <CircularProgress />
        )}
        <br />
        {!isLoading && isLoaded && (
          <div>
            <Typography
              className={classes.sectionHeading}
              variant="h5"
              component="h5"
            >
              {headingText}
            </Typography>
            {meta && meta.guideline_text && (
              <Typography className={classes.guidelineText}>
                {meta.guideline_text}
              </Typography>
            )}
            <div className={classes.scoresWrapper}>
              {meta && meta.score_labels && scores.map((thisScore) => {
                let { scoreWrapper } = classes;
                if (thisScore === score) {
                  scoreWrapper = `${classes.scoreWrapper} ${classes.scoreWrapperActive}`;
                }

                return (
                  <div
                    key={thisScore}
                    className={scoreWrapper}
                    onClick={this.onScoreClick.bind(this, thisScore)}
                  >
                    <img src={`${rootUrl}/img/tracking/${thisScore}.png`} />
                    {meta.score_labels[thisScore] && (
                      <Typography
                        variant="h6"
                        component="h6"
                        className={`score-${thisScore} ${classes.scoreLabel}`}
                      >
                        {meta.score_labels[thisScore]}
                      </Typography>
                    )}
                  </div>
                );
              })}
            </div>
            {score !== null && (
              <div>
                <div>
                  <TextField
                    placeholder={t('Add note (optional)')}
                    multiline
                    rows="4"
                    value={note}
                    onChange={this.onInputChange}
                    className={`add-note ${classes.noteField}`}
                    name="note"
                    margin="normal"
                  />
                </div>
                <div>
                  <Grid
                    container
                    spacing={4}
                  >
                    <Grid
                      item
                      md={4}
                      sm={12}
                    >
                      <DateTimePicker
                        autoOk
                        ampm={false}
                        disableFuture
                        format={`${dateFormat} HH:mm`}
                        value={timestamp}
                        onChange={(timestamp) => {
                          this.setState({
                            timestamp,
                          });
                        }}
                        label={t('Timestamp')}
                        name="timestamp"
                        className={`add-timestamp ${classes.formControl}`}
                      />
                    </Grid>
                    <Grid
                      item
                      md={4}
                      sm={12}
                    >
                      {meta?.trackers && Object.keys(meta.trackers).length > 0 && (
                        <FormControl className={classes.formControl}>
                          <InputLabel shrink htmlFor="tracker">
                            {t('Tracker')}
                          </InputLabel>
                          <Select
                            value={tracker}
                            onChange={this.onInputChange}
                            input={<Input name="tracker" id="tracker" />}
                            displayEmpty
                            name="tracker"
                          >
                            {selectedPupil.display_mental_health_no_tracker && (
                              <MenuItem value="">
                                <em>
                                  <span>--</span>
                                  {t('none')}
                                  <span>--</span>
                                </em>
                              </MenuItem>
                            )}
                            {Object.keys(meta.trackers).map(trackerId => (
                              <MenuItem
                                key={trackerId}
                                value={trackerId}
                              >
                                {meta.trackers[trackerId]}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Grid>
                    <Grid
                      item
                      md={4}
                      sm={12}
                      className={classes.textAlignRight}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.onSaveClick}
                        className={`save-button ${classes.saveButton}`}
                      >
                        {t('Save')}
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </div>
            )}
          </div>
        )}
        <Divider className={classes.divider} />
        <div>
          {!isLoading && isLoaded && data.length > 0 && data.map((mentalHealthEntry) => {
            const date = moment(mentalHealthEntry.timestamp).format('YYYY-MM-DD');
            if (lastDate !== date) {
              lastDate = date;

              return (
                <div key={mentalHealthEntry.id}>
                  <Typography
                    className={classes.sectionSubHeading}
                    variant="h6"
                    component="h6"
                  >
                    {moment(date).format('dddd D MMMM YYYY')}
                  </Typography>
                  <MentalHealthEntryCard
                    key={mentalHealthEntry.id}
                    mentalHealthEntry={mentalHealthEntry}
                    useSuspense={false}
                    onDeleteClick={this.onDeleteClick.bind(this, mentalHealthEntry)}
                    onEditClick={this.onEditClick.bind(this, mentalHealthEntry)}
                    userId={user.id}
                  />
                </div>
              );
            }

            return (
              <MentalHealthEntryCard
                key={mentalHealthEntry.id}
                mentalHealthEntry={mentalHealthEntry}
                useSuspense={false}
                onDeleteClick={this.onDeleteClick.bind(this, mentalHealthEntry)}
                onEditClick={this.onEditClick.bind(this, mentalHealthEntry)}
                userId={user.id}
              />
            );
          })}
          {!isLoading && isLoaded && data.length === 0 && (
            <div>{t('No wellbeing entries at the moment.')}</div>
          )}
        </div>
        <ConfirmDialog
          useSuspense={false}
          title={t('Confirmation')}
          isOpen={isDialogOpen}
          onClose={this.onDialogClose}
          onConfirm={this.onDialogConfirm}
        >
          {dialogText}
        </ConfirmDialog>
        <MentalHealthEditDialog
          isOpen={isEditDialogOpen}
          onClose={this.onEditDialogClose}
          onConfirm={this.onEditDialogConfirm}
          onInputChange={this.onInputChange}
          onDatepickerChange={(timestamp) => {
            const { editDialogData } = this.state;
            editDialogData.timestamp = timestamp;
            this.setState({
              editDialogData,
            });
          }}
          data={editDialogData}
          meta={meta}
          dateFormat={dateFormat}
          displayNoTracker={selectedPupil.display_mental_health_no_tracker}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withSnackbar(withTranslation()(MentalHealthPage)))
);
